export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen pt-32 pb-16 px-8 overflow-hidden">
      {/* Fondo decorativo */}
      <div className="absolute inset-0 opacity-5">
        <svg className="absolute top-20 left-0 w-96 h-96" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          <path fill="#2d5a8f" d="M47.1,-57.8C59.9,-49.2,68.5,-33.3,71.3,-16.2C74.1,0.9,71.1,19.2,62.5,34.4C53.9,49.6,39.7,61.7,23.6,67.2C7.5,72.7,-10.5,71.6,-26.3,65.3C-42.1,59,-55.7,47.5,-64.4,32.7C-73.1,17.9,-76.9,-0.2,-73.5,-16.7C-70.1,-33.2,-59.5,-48.1,-45.4,-56.3C-31.3,-64.5,-15.7,-65.9,1.1,-67.3C17.9,-68.7,34.3,-66.4,47.1,-57.8Z" transform="translate(100 100)" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 items-center relative z-10">
        {/* Contenido Izquierdo */}
        <div className="space-y-8">
          <div className="inline-block bg-[#ffd166] px-4 py-2 rounded-full">
            <span className="text-sm font-medium text-[#1a2332]">💡 Consejo del Día</span>
          </div>

          <h1 className="text-7xl font-bold leading-tight">
            <span className="block text-[#1a2332]">Tu Futuro</span>
            <span className="block text-[#1a2332]">Merece Estar</span>
            <span className="block text-[#2d5a8f]">Protegido</span>
          </h1>

          <p className="text-2xl text-gray-600 font-light">
            Finanzas Educadas y Protegidas
          </p>

          <p className="text-lg text-gray-700 leading-relaxed max-w-xl">
            Un plan financiero sólido requiere dos pilares fundamentales: ahorro inteligente y protección estratégica. Construye tu futuro con bases sólidas que te protejan ante cualquier imprevisto.
          </p>

          <div className="flex gap-4">
            <button
              onClick={() => scrollToSection('metodo-fep')}
              className="bg-[#1a2332] text-white px-8 py-4 rounded-lg hover:bg-[#2d5a8f] transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap"
            >
              Conoce el Método FEP
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollToSection('testimonios')}
              className="border-2 border-[#1a2332] text-[#1a2332] px-8 py-4 rounded-lg hover:bg-[#1a2332] hover:text-white transition-all cursor-pointer whitespace-nowrap"
            >
              Ver Testimonios
            </button>
          </div>
        </div>

        {/* Tarjetas Visuales Derecha */}
        <div className="relative h-[600px] hidden md:block">
          {/* Tarjeta trasera - Escudo */}
          <div className="absolute top-0 right-0 w-72 h-80 bg-gradient-to-br from-[#2d5a8f] to-[#14B8A6] rounded-3xl shadow-2xl flex items-center justify-center transform rotate-6">
            <div className="w-32 h-32 flex items-center justify-center">
              <i className="ri-shield-check-line text-white text-8xl"></i>
            </div>
          </div>

          {/* Tarjeta media - Gráfico */}
          <div className="absolute top-32 right-20 w-80 h-64 bg-white rounded-3xl shadow-2xl p-6 transform -rotate-3">
            <div className="mb-4">
              <h3 className="text-lg font-semibold text-[#1a2332]">Crecimiento Protegido</h3>
              <p className="text-sm text-gray-600">Tu patrimonio seguro</p>
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div className="bg-[#14B8A6] h-3 rounded-full" style={{ width: '85%' }}></div>
                </div>
                <span className="text-sm font-semibold whitespace-nowrap">85%</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div className="bg-[#2d5a8f] h-3 rounded-full" style={{ width: '92%' }}></div>
                </div>
                <span className="text-sm font-semibold whitespace-nowrap">92%</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="w-full bg-gray-200 rounded-full h-3">
                  <div className="bg-[#ffd166] h-3 rounded-full" style={{ width: '78%' }}></div>
                </div>
                <span className="text-sm font-semibold whitespace-nowrap">78%</span>
              </div>
            </div>
            <div className="mt-6 flex items-center gap-2 text-[#14B8A6]">
              <i className="ri-arrow-up-line text-2xl"></i>
              <span className="font-bold text-xl">+24%</span>
              <span className="text-sm text-gray-600">este año</span>
            </div>
          </div>

          {/* Tarjeta frontal - Familia */}
          <div className="absolute top-64 right-40 w-96 h-80 rounded-3xl shadow-2xl overflow-hidden transform rotate-2">
            <img
              src="https://public.readdy.ai/ai/img_res/7b2fc559eca777af4a56aeb0449139c7.jpg"
              alt="Familia protegida"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-[#2d5a8f]/20"></div>
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-4">
              <p className="text-sm font-semibold text-[#1a2332]">+200 Familias Protegidas</p>
              <p className="text-xs text-gray-600 mt-1">Confiando en nuestro método</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
